/**
 * Returns a list of valid book level values.
 */
export function generateValidBookLevelValues(){
    let inputs = [];
    const lowestValidInput = 0.1;
    const highestValidInput = 13.9;
    
    for(let i = lowestValidInput; i<=highestValidInput; i+= 0.1){
        inputs.push(Number(i).toFixed(1));
    }

    let validatedInput = cleanBookLevelInputs(inputs);

    return validatedInput;
}

/**
 * Returns an object with interest level acronyms as key and their verbose name as values
 */
export function getValidInterestLevels() {
    return [
        {val: "LG", displayText: "Lower Grades" },
        {val: "MG", displayText: "Middle Grades"},
        {val: "MG+", displayText: "Upper Middle Grades"},
        {val: "UG", displayText: "Upper Grades"}
    ] 
}

/**
 * Removes invalid book level inputs and returns a cleaned list of valid book
 * @param {[string]} inputs BookLevel values from 0.1 to 13.9
 */
function cleanBookLevelInputs(inputs){
    return inputs.map(val => {

        if(isWholeNumber(val)){
            return replaceFloatWithWholeNumber(val)
        }
        return val;       
    });
}

/**
 * Returns true if whole number
 * @param {*} number 
 */
function isWholeNumber(number){
    return number % 1 === 0;
}

/**
 * Replaces floaty whole numbers with integers i.e. 1.0 as 1 
 * @param {*} number 
 */
function replaceFloatWithWholeNumber(number){
    return number.replace(".0", "");
}




// WEBPACK FOOTER //
// ./src/lib/acceleratedReader/AcceleratedReaderInputUtilities.js